import { TFieldProps } from 'types';

export const initialValues = {
  comment: '',
};

export const fields: TFieldProps[] = [{
  type: TFieldProps.type.Textarea,
  name: 'comment',
  maxLength: 256,
  showCount: true,
  placeholder: 'Write comment',
  autoSize: {
    minRows: 5,
    maxRows: 5,
  },
  rules: [{
    required: true,
    message: 'Comment is required!',
  }, {
    min: 5,
    message: 'Min length should be 5 symbols!',
  }, {
    max: 256,
    message: 'Max length should be 256 symbols!',
  }],
}];
